export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboard.text",
        icon: "bx-home-circle",
        link: '/',
        meta: ['has-marketplace', 'has-subscription']
    },
    {
        id: 2,
        label: "menuitems.feedback.text",
        icon: "bxs-conversation",
        link: "/feedback",
        meta: ['has-marketplace', 'has-subscription']
    },
    {
        id: 3,
        label: "menuitems.reviews.text",
        icon: "bxs-comment-dots",
        link: "/reviews",
        meta: ['has-subscription']
    },
    {
        id: 4,
        label: "menuitems.campaigns.text",
        icon: "bx-notification",
        link: "/campaigns",
        meta: ['has-marketplace', 'has-subscription'],
        subItems: [
            {
                id: 5,
                label: 'menuitems.campaigns.text',
                link: "/campaigns",
                parentId: 4,
                icon: "bx-envelope",
            },
            {
                id: 6,
                label: 'menuitems.campaigns.template',
                link: '/campaigns/templates',
                parentId: 4,
                icon: "bx-edit"
            },
            {
                id: 7,
                label: 'menuitems.campaigns.queue',
                link: '/campaigns/queue',
                parentId: 4,
                icon: "bx-mail-send",
            },
        ]
    },
    {
        id: 8,
        label: "menuitems.catalog.text",
        icon: "bx-store",
        link: "/catalog",
        meta: ['has-marketplace', 'has-subscription']
    },
    {
        id: 9,
        label: "menuitems.orders.text",
        icon: "bx-shopping-bag",
        link: "/orders",
        meta: ['has-marketplace', 'has-subscription']
    },
    {
        id: 10,
        label: "menuitems.customers.text",
        icon: "bxs-user-detail",
        link: "/customers",
        meta: ['has-marketplace', 'has-subscription']
    },
    {
        id: 11,
        label: 'menuitems.smart_tools.product_research',
        link: "/smart-tools/magic-product-research",
        icon: "bx-package",
        meta: ['has-subscription']
    },
    {
        id: 12,
        label: 'menuitems.smart_tools.keyword_tool',
        link: '/smart-tools/keyword-tool',
        icon: "bx-spreadsheet",
        meta: ['has-subscription']

    },
    {
        id: 13,
        label: 'menuitems.smart_tools.bg_remover',
        link: '/smart-tools/bg-remover',
        icon: "bx-images",
        meta: ['has-subscription']
    }
];

